'use client'
import { Stack, VStack } from '@chakra-ui/react'
import { EmptyMessage, GrandNextLink } from 'ui'
import { overrideText } from 'ui/lib/overrides'
import { useOverridesContext } from 'ui/lib/overrides/hooks'
import { useCheckoutContext } from '../hooks'
import CheckoutSummary from './CheckoutSummary'
import { CheckoutCart } from './CheckoutCart'

export interface CheckoutOverrides {
  checkoutNewsLetter?: string
  newsLetterInputLabel?: string
  emptyCart?: string
  emptyCartBtnLabel?: string
}

const Checkout = () => {
  const {
    cartState: { cartItems }
  } = useCheckoutContext()
  const overrides = useOverridesContext<keyof CheckoutOverrides>()

  if (!cartItems.length) {
    return (
      <EmptyMessage
        extraComponent={
          <GrandNextLink aria-label="Börja shoppa" href="/" isButton px={4}>
            {overrideText('Börja shoppa', overrides?.emptyCartBtnLabel)}
          </GrandNextLink>
        }
        text={overrideText(
          'Din varukorg är tom, försök lägga till några varor.',
          overrides?.emptyCart
        )}
      />
    )
  }

  return (
    <VStack>
      <Stack
        align="stretch"
        direction={{
          base: 'column',
          md: 'row'
        }}
        w="full"
      >
        <CheckoutCart flex={1} />
        <VStack flex={0.8} spacing={8}>
          <CheckoutSummary />

          {/*https://favro.com/organization/45084b7a11210125ba2cd917/7b4ae4354708aa8a2fd2e45c?card=Gra-2289*/}
          {/*<CheckoutEmailSubscription />*/}
        </VStack>
      </Stack>
    </VStack>
  )
}

export default Checkout
